import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import { isNotOnPublicPage } from '@/utils/http';

export const NEW_UI_VERSION = 'new';

const uiVersion = ref(NEW_UI_VERSION);

function applyUiVersion () {
    uiVersion.value = NEW_UI_VERSION;
    document.documentElement.setAttribute('data-ui', NEW_UI_VERSION);
}

export default function useUiVersion () {
    const route = useRoute();

    const initializeUiVersion = () => {
        if (isNotOnPublicPage()) {
            applyUiVersion();
        } else {
            const unwatch = watch(() => route.path, (newPath) => {
                if (newPath && isNotOnPublicPage()) {
                    unwatch();
                    applyUiVersion();
                }
            });
        }
    };

    const isNewUi = computed(() => {
        return uiVersion.value === NEW_UI_VERSION;
    });

    return {
        isNewUi,
        initializeUiVersion,
    };
}
